export default () => (
  /**
   * Ícone ponta de seta apontada para direita
   */
  <svg
    width="7"
    height="11"
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      marginLeft: 10,
    }}
  >
    <path
      d="M1.16493 0.3396C1.21399 0.295851 1.2712 0.262214 1.33329 0.240619C1.39537 0.219023 1.46111 0.209893 1.52673 0.213753C1.59235 0.217612 1.65656 0.234385 1.71568 0.263109C1.77481 0.291834 1.82768 0.331945 1.87127 0.381144L5.87549 4.88589C5.95695 4.97745 6.00195 5.09573 6.00195 5.21829C6.00195 5.34084 5.95695 5.45913 5.87549 5.55069L1.87128 10.0554C1.78198 10.1503 1.65922 10.2066 1.52907 10.2124C1.39893 10.2182 1.27165 10.173 1.17428 10.0865C1.07691 9.99991 1.01712 9.8788 1.00762 9.74887C0.998116 9.61894 1.03965 9.49043 1.12339 9.39063L4.83189 5.21829L1.12339 1.04594C1.07969 0.996858 1.0461 0.939639 1.02454 0.877561C1.00298 0.815483 0.993869 0.749763 0.997727 0.68416C1.00159 0.618557 1.01834 0.554358 1.04703 0.495235C1.07572 0.436113 1.11578 0.383226 1.16493 0.3396Z"
      fill="#5E5E5E"
    />
  </svg>
);
